let uploads = [];


const highlight_drop_area = () =>
{
  if ( !cached_elements.has_class( '#js-photo-drag-area', 'active' ) )
  {
    cached_elements.add_class( '#js-photo-drag-area', 'active' );
  }
};


const unhighlight_drop_area = ( e, drop ) =>
{
  if ( is_event_outside_dragarea_bounds( e ) || drop )
  {
    if ( cached_elements.has_class( '#js-photo-drag-area', 'active' ) )
    {
      cached_elements.remove_class( '#js-photo-drag-area', 'active' );
    }
  }
};


const is_event_outside_dragarea_bounds = ( e ) =>
{
  const drag_area_pos = cached_elements.get_node( '#js-photo-drag-area' ).getBoundingClientRect();

  return e.clientX < drag_area_pos.left || e.clientY < drag_area_pos.top || e.clientX > drag_area_pos.right || e.clientY > drag_area_pos.bottom ? true : false;
};


const handle_drop = ( e ) =>
{
  handle_files( e.dataTransfer.files );
};


const handle_files = ( files ) =>
{
  prepare_file_upload_area();

  add_file_upload_area_title();

  add_files_details( [ ...files ] );

  add_file_upload_area_tagline();

  init_upload_progress_bar();
};


const prepare_file_upload_area = () =>
{
  uploads = [];
  cached_elements.get_node( '#js-photo-drag-area' ).style.display = 'none';
  remove_children( cached_elements.get_node( '#js-photo-uploads' ) );
}


const add_file_upload_area_title = () =>
{
  const upload_title = new Element( { element: 'h4', content: 'Photo Uploads', classes: [ 'social__status-photo-uploads-title' ] } ).returnElement();
  cached_elements.get_node( '#js-photo-uploads' ).appendChild( upload_title );
}


const add_files_details = ( files ) =>
{
  files.forEach( ( file, i ) =>
  {
    cached_elements.get_node( '#js-photo-uploads' ).appendChild( create_upload_markup( file, i ) );

    const countUp = create_countup_instance( `upload-${i+1}`, 0, file.size );

    uploads.push(
    {
      instance: countUp,
      progress: cached_elements.get_node( `[data-upload="upload-${i+1}"]` )
    } );

  } );
};

create_countup_instance = ( id, start_val, end_val ) =>
{
  return new CountUp( id, end_val,
  {
    startVal: start_val,
    suffix: 'KB',
    duration: 12,
    separator: '',
    useEasing: false,
    smartEasingAmount: 0
  } );
};


const create_upload_markup = ( file, i ) =>
{
  const tile = new Element( { classes: [ 'social__status-photo-uploads-tile' ] } );

  const file_name = new Element( { element: 'h4', content: file.name } );

  const file_progress = file_progress_markup( i );

  const file_size = file_size_markup( i, file.size );

  return tile.append( file_name ).append( file_progress.append( file_size.returnElement() ) ).returnElement();
};


const file_progress_markup = ( i ) =>
{
  const file_progress = new Element( { classes: [ 'social__status-photo-uploads-progress' ] } );
  const file_progress_inner = new Element( { classes: [ 'social__status-photo-uploads-progress-inner' ], attributions: { attribute: 'data-upload', value: `upload-${i+1}` } } ).returnElement();
  file_progress.append( file_progress_inner );
  return file_progress;
}


const file_size_markup = ( i, size ) =>
{
  const file_size = new Element( { element: 'h6' } );
  const file_size_start = new Element( { element: 'span', content: '0', id: `upload-${i+1}` } ).returnElement();
  const file_size_total = new Element( { element: 'span', content: `${size}KB` } ).returnElement();
  file_size.append( file_size_start ).append( ' / ' ).append( file_size_total );
  return file_size;
}


const add_file_upload_area_tagline = () =>
{
  const upload_tagline = new Element( { element: 'p', content: 'Please wait while we add this to the 1,029,829,380 other pieces of information we have about you.', classes: [ 'social__status-photo-uploads-tagline' ] } ).returnElement();
  cached_elements.get_node( '#js-photo-uploads' ).appendChild( upload_tagline );
}


const init_upload_progress_bar = () =>
{
  cached_elements.get_node( '#js-photo-uploads' ).style.display = 'flex';

  for ( const obj of uploads )
  {
    obj.instance.start();

     window.requestAnimationFrame( () =>
    {
      tick(obj.instance, obj.progress);
    } )
  }
};

const tick = ( instance, node ) =>
{
  if ( instance.remaining >= 0)
  {
    const percentage = ( instance.frameVal  / instance.endVal ) * 100;
    window.requestAnimationFrame( () =>
    {
      node.style.width = `${percentage}%`;
      tick( instance, node );
    });

  } else {
    node.style.width = `100%`;
  }
}
